import en from './en'
import tr from './tr'
export default {
	en: en,
	tr: tr
};